import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { FormattedHTMLMessage } from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner.js';
import CustomAlert from './CustomAlert.js';
import FlowProgressBar from './FlowProgressBar.js';
import Header from './Header.js';
import LeadInfo from './LeadInfo.js';
import Summary from './Summary.js';

require(`../assets/${process.env.PAGE}/css/components/CheckOut.css`);
class Checkout extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                        <FormattedHTMLMessage id="app.step_checkout" description="Checkout info" />
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <form onSubmit={handleSubmit(this.props.saveCompletedCheckOut)} className="pvc-form">
                                {this.props.isLoading && <CustomSpinner message='Estamos buscando tu auto ideal' />}
                                {error && <CustomAlert bsStyle="danger" message={error} />}
                                <Summary />
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

Checkout = TopScrolleable(Checkout);

Checkout = reduxForm({
    form: 'Checkout', // a unique name for this form
})(Checkout);

Checkout = LeadInfo(Checkout);
Checkout = withAuthControl(Checkout);

export default Checkout;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOut.js
 **/